/**
 * this is shit code - -
 */
import { useLayoutFolder, useMenu } from '@/store';
import type { TItem, TItemAttrs } from '@/components/GridBoards/types';
import APP_ITEMS from '../items/apps';
import { createFolder } from '../layoutItems';

const useFolders = (screen: number, siderbounds: LayoutBoxSiderbounds) => {
  const [folder, updateLayoutFolder] = useLayoutFolder();
  const [{ thirdApp = [] }] = useMenu();

  const curScreenFolders = (folder || []).filter((f) => {
    return f.screen === screen;
  });

  // map folder to TItem
  const result = curScreenFolders.map<TItem>((item) =>
    createFolder(item, siderbounds),
  );

  // 更新folder
  const updateFolders = (items: TItem[]) => {
    const tmp: PropType<ConfigLayout, 'folder'> = items
      .filter(({ isFolder }) => isFolder)
      .map((i) => {
        return {
          screen: screen,
          title: i.title || '',
          x: i.x,
          y: i.y,
          child: i.child || [],
        };
      });

    const _folder = folder!.filter((f) => f.screen !== screen);

    updateLayoutFolder([...tmp, ..._folder]);
  };

  /**
   * 拖入app时修改对应的folder child操作
   */
  const insertAppToFolderIfValid = (
    maybeApp: TItem,
    maybeFolder: TItem,
    itemAttrs: TItemAttrs,
  ) => {
    if (maybeApp.isApp && maybeFolder.isFolder) {
      const fid = maybeFolder.id;
      const appId = maybeApp.id.split('-')[0] as keyof typeof APP_ITEMS;

      let className = '';
      let packageName = '';
      if (APP_ITEMS[appId]) {
        className = APP_ITEMS[appId].className;
        packageName = APP_ITEMS[appId].packageName;
      } else {
        const mta = thirdApp.find((tha) => tha.className === appId);
        if (mta) {
          className = mta.className;
          packageName = mta.packageName;
        }
      }

      return {
        ...itemAttrs,
        [fid]: {
          ...itemAttrs[fid],
          child: [
            ...(itemAttrs[fid].child || []),
            {
              className,
              packageName,
            },
          ],
        },
      } as TItemAttrs;
    }
    return undefined;
  };

  return {
    folders: result,
    insertAppToFolderIfValid,
    updateFolders,
    createFolder,
  };
};

export default useFolders;
